import moment from 'moment';

/**
 * Format date to DD/MM/YYYY HH:mm without timezone offset
 * @param date Date string or Date object
 * @returns Formatted date string or empty string if date is falsy
 */
export const formatDateTime = (date: string | Date | null | undefined): string => {
  return date ? moment.utc(date).format('DD/MM/YYYY HH:mm') : '';
};

/**
 * Format date to DD/MM/YYYY without timezone offset
 * @param date Date string or Date object
 * @returns Formatted date string or empty string if date is falsy
 */
export const formatDate = (date: string | Date | null | undefined): string => {
  return date ? moment.utc(date).format('DD/MM/YYYY') : '';
};

/**
 * Format date range with start and end dates
 * @param startDate Start date string or Date object
 * @param endDate End date string or Date object
 * @returns Formatted date range string or empty string if both dates are falsy
 */
export const formatDateTimeRange = (
  startDate: string | Date | null | undefined,
  endDate: string | Date | null | undefined
): string => {
  if (!startDate && !endDate) return '';
  
  const formattedStart = startDate ? formatDateTime(startDate) : '';
  const formattedEnd = endDate ? formatDateTime(endDate) : '';
  
  if (formattedStart && formattedEnd) {
    return `${formattedStart} - ${formattedEnd}`;
  }
  
  return formattedStart || formattedEnd;
};